export default {
  getLatestNews (cb, errorCb) {
    axios.get('/news/current')
      .then(response => cb(response))
      .catch(err => {
        if (typeof errorCb === 'function') {
          errorCb(err)
        }
      })
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/app/api/news.js